import React, { useEffect, useState } from "react";
import { fetchData } from "../../Components/common/utils";
import Vehicle_Card from "../../Components/common/ui/Vehicle_Card";
import { useParams } from "react-router-dom";
import MainLoader from "../../Components/MainLoader";
import { useLocation } from "react-router-dom";
const CompanyProducts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const location = useLocation();
  const [categoryName, setCategoryName] = useState({});
  useEffect(() => {

    const fetchApiData = async () => {
      const url = "api/product/logo/" + id;
      const result = await fetchData(url);

      if (result && result.data) {
        const filteredProducts = result.data.filter(
          (product) => product.category.slug === id
        );
         if (result.data.length >= 1) {
          setCategoryName(result.data[0].category)
        }
        setData(filteredProducts);
      }
      setLoading(false);
    };
    fetchApiData();
  }, [id, location.pathname]);

  return (
    <div className="mt-4">
      {loading && <MainLoader />}
      {/* <Latest_Product /> */}

      {data.length === 0 ? (
        <div className="container">
          <div className="text-center no-found-text">
            <h3>Sorry! No Vehicle Found.</h3>
          </div>
        </div>
      ) : (
        <div>
          <div className=" container mt-4">
            {/* Modern Header */}
            <div className="brand-banner py-3 px-3 text-center text-white mb-4">
              <h1 className="display-4 fw-bold mb-2">Welcome to <span className="brand-name">{categoryName?.title}</span></h1>
              <p className="lead">{categoryName?.description}</p>
            </div>
          </div>
          <Vehicle_Card
            title={"Explore Latest Models"}
            VehicleDetails={data}
          />
        </div>
      )}
      {/* <Vehicle_Review /> */}
    </div>
  );
};

export default CompanyProducts;
